<script setup lang="ts">
import { computed, PropType } from 'vue';
import type { SupplierbranchDisplayFragment } from './SupplierbranchDisplay.generated';
import { ComposedNameSpan } from '@precon-tools-suite-by-shared/shared-names-ui';

const props = defineProps({
    node: {
        type: Object as PropType<SupplierbranchDisplayFragment>,
        default: undefined,
    },
    status: {
        type: Boolean,
        default: false,
    },
    clientRef: {
        type: Boolean,
        default: false,
    },
    reliability: {
        type: Boolean,
        default: false,
    },
});

const node = computed(() => props.node);
const state = computed(() => (node.value?.isActive ? 'Actief' : 'Inactief'));
const clientRefValue = computed(() => node.value?.supplier?.clientRef);
const reliabilityValue = computed(() => node.value?.reliability?.name?.short);
</script>
<template>
    <div style="width: 100%">
        <table style="width: 100%">
            <tbody>
                <tr>
                    <td v-if="props.clientRef" style="width: 25%">
                        {{ clientRefValue }}
                    </td>
                    <td style="width: 60%">
                        <ComposedNameSpan
                            :node="node"
                            short
                            style="font-weight: bold"
                        />
                    </td>
                    <td v-if="props.status" style="width: 15%">
                        {{ state }}
                    </td>
                    <td v-if="props.reliability">
                        {{ reliabilityValue }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
